import { nonRunnerSelectionComparer } from "../nonRunnerSelectionComparer";
export function sortSelectionsByOdd(s1, s2) {
    return nonRunnerSelectionComparer(s1, s2) || s1.trueOdds - s2.trueOdds;
}
//# sourceMappingURL=sortSelectonsByOdd.js.map